import * as React from 'react';
import Container from '@mui/material/Container';
import {Typography,Box, Card, CardMedia, Paper} from "@mui/material";

export default function LandingUser () {


    return (

        <Container maxWidth={false} disableGutters>
            <Box sx={{ position: 'relative' }}>
                {/* Video de fondo */}
                <CardMedia
                component="video"
                src="https://club-vip-media.s3.amazonaws.com/videos/userlanding.mp4"
                autoPlay
                loop
                muted
                playsInline
                sx={{ width: '100%', height: 'auto', display: 'block' }}
                />

                {/* Overlay */}
                <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    bgcolor: 'rgba(0,0,0,0.54)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: { xs: 2, sm: 4, md: 6 }, 
                }}
                >
                <Typography
                    color="white"
                    textAlign="center"
                    sx={{
                    fontWeight: 700,
                    // tamaño responsivo
                    fontSize: { xs: '6vw', sm: '5vw', md: '3.5vw', lg: '3vw' },
                    lineHeight: 1.1,
                    whiteSpace: 'normal',     
                    wordBreak: 'break-word',  
                    maxWidth: '1200px',
                    }}
                >
                    BIENVENIDO AL CLUB DE GOLF MÁS GRANDE DEL MUNDO
                </Typography>
                </Box>
            </Box>
        </Container>
    )

}